export default __webpack_public_path__ + "static/media/univbackground.33ff470c.jpg";